module.exports = __webpack_public_path__ + "static/media/img5.b4a99aff.jpeg";